const translate = (t, key, fallback) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key)

  return translated === key ? fallback : translated
}

const inlineFilterItems = (t) => [
  {
    id: 'all',
    label: translate(t, 'global.filter.all', 'Semua'),
  },
  {
    id: 'WAITING',
    label: translate(t, 'deliveryRequest.status.waiting', 'Menunggu Vendor'),
  },
  {
    id: 'ACCEPTED',
    label: translate(t, 'deliveryRequest.status.accepted', 'Diterima'),
  },
  {
    id: 'REJECTED',
    label: translate(t, 'deliveryRequest.status.rejected', 'Ditolak'),
  },
]

export default inlineFilterItems
